export var OFFER_DETAIL_ROUTE = 'index.customercare.customer.offer';
export function routing($stateProvider) {
  $stateProvider.state(OFFER_DETAIL_ROUTE, {
    //Used for pending offer changes.  Subscription is retrieved by offerId
    url: '/offer/:offerId',
    template: '<subscription-detail></subscription-detail>'
  });
}